import { isSSR } from './isSSR.js';

var isDarkTheme = function isDarkTheme() {
  if (isSSR()) {
    return false;
  } // all webview pages in TT would have the isDarkMode flag


  var matches = navigator.userAgent.match(/isDarkMode\/([01])/);

  if (!matches) {
    var isSupported = Boolean(window.matchMedia);
    return isSupported && window.matchMedia('(prefers-color-scheme: dark)').matches;
  }

  return matches[1] === '1';
};

var getDefaultTheme = function getDefaultTheme() {
  if (isSSR()) {
    return undefined;
  }

  return isDarkTheme() ? 'dark' : 'light';
};

var theme = getDefaultTheme();

export { isDarkTheme, theme };
//# sourceMappingURL=theme.js.map
